import store from '@/store'
import * as config from '../config.js';
import { conLog } from './utility';

var wsuri = 'ws://'+config.address2+':61614'
var websock = null;
// var count = 0;//断开重连计数
// var MAX = 1000;//最大重连次数
var connetClose = '';//重连定时器
var sendMsg = null;

//初始化weosocket 
function initWebSocket(msg){ 
  sendMsg = msg
  //wsuri:地址，gkws_v1：协议名称（多个可以用 ['protocol1','protocol2',...]）
  websock = new WebSocket(wsuri,'mqtt');
  websock.onopen = websocketonopen;
  websock.onerror = websocketonerror;
  websock.onmessage = websocketonmessage; 
  websock.onclose = websocketclose;
}
function websocketonopen() {
  conLog("ws连接成功");
  if(sendMsg){
    websock.send(sendMsg)
    conLog('wssend1',sendMsg)
  }
}
//错误
function websocketonerror(e) { 
  conLog("ws连接异常",e);
  websock.close()
  conLog('准备重连error')
  reconnection()
}
//数据接收 
function websocketonmessage(e){ 
  // const redata = JSON.parse(e.data);
  var redata = e.data
  //注意：长连接我们是后台直接1秒推送一条数据， 
  //但是点击某个列表时，会发送给后台一个标识，后台根据此标识返回相对应的数据，
  //这个时候数据就只能从一个出口出，所以让后台加了一个键，例如键为1时，是每隔1秒推送的数据，为2时是发送标识后再推送的数据，以作区分
  redata = JSON.parse(redata)
  store.commit('wsMsg',redata)
  conLog('ws接收',redata)
  // sessionStorage.setItem('wsMsg',redata)

}
//数据发送 
function websocketsend(agentData){
  conLog('ws发送',agentData)
  websock.send(agentData); 
}
//ws断开重连
function reconnection() {
  // count = count + 1;
  
  //1与服务器已经建立连接
  if (websock.readyState == 1) {
    conLog('ws重连成功')
    clearTimeout(connetClose);
    // count = 0
  } else {
    //3已经关闭了与服务器的连接
    if (websock.readyState == 3) {
      // count = 0
      clearTimeout(connetClose);
      initWebSocket();
    }else{
      //0正尝试与服务器建立连接,2正在关闭与服务器的连接
      conLog('准备重连')
      connetClose = setTimeout(function() {
        reconnection();
      }, 1000);
    }
  }
  
}
//关闭 
function websocketclose(e){
  conLog("ws已关闭",e);
  conLog(e.code + ' ' + e.reason + ' ' + e.wasClean)
  // websock.close()
  conLog('准备重连close')
  reconnection()
}

export {
  initWebSocket,
  websocketonopen,
  websocketonerror,
  websocketonmessage,
  websocketsend,
  websocketclose,
  reconnection
}


//////////////////
// WEBPACK FOOTER
// ./static/js/utils/socket.js
// module id = null
// module chunks = 